import { FormGroup } from '@angular/forms';

/**
 * Serializes a widget block's full state (settings + enabled flag) for unsaved-change detection.
 * Value-based on purpose: the editors write many controls via setValue(), which never marks them dirty.
 */
export function serializeBlockState(formGroup: FormGroup, enabled: boolean): string {
  return JSON.stringify({ enabled, settings: formGroup.getRawValue() }, fileReplacer);
}

function fileReplacer(_key: string, value: unknown): unknown {
  if (value instanceof File) return `file:${value.name}:${value.size}`;
  if (value instanceof Blob) return `blob:${value.size}`;
  return value;
}
